import notoSans400woff from '$lib/fonts/noto-sans-400.woff';
import notoSans400woff2 from '$lib/fonts/noto-sans-400.woff2';
import notoSans900woff from '$lib/fonts/noto-sans-900.woff';
import notoSans900woff2 from '$lib/fonts/noto-sans-900.woff2';

import notoSansJP400woff from '$lib/fonts/noto-sans-jp-400.woff';
import notoSansJP400woff2 from '$lib/fonts/noto-sans-jp-400.woff2';
import notoSansJP900woff from '$lib/fonts/noto-sans-jp-900.woff';
import notoSansJP900woff2 from '$lib/fonts/noto-sans-jp-900.woff2';

export const fontUrls = {
  default: {
    400: {
      woff: notoSans400woff,
      woff2: notoSans400woff2,
    },
    900: {
      woff: notoSans900woff,
      woff2: notoSans900woff2,
    },
  },
  jp: {
    400: {
      woff: notoSansJP400woff,
      woff2: notoSansJP400woff2,
    },
    900: {
      woff: notoSansJP900woff,
      woff2: notoSansJP900woff2,
    },
  },
};
